import { render, staticRenderFns } from "./DepartmentTable.vue?vue&type=template&id=61a7e2a8"
import script from "./DepartmentTable.vue?vue&type=script&lang=js"
export * from "./DepartmentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports